<template>
  <div>
    <div class="container">
      <img class="activity-img" src='../../assets/images/activity/video-banner-detail.png' />

      <img class="gotoBtn" @click='goEnroll()' src="../../assets/images/activity/video-toBtn.png">
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
export default {
  data () {
    return {
      from: ''
    }
  },
  mounted () {
    this.from = this.$route.query.from
    if (this.from) {
      sessionStorage.setItem('workshop-video-from', this.from)
    }
    commonUtils.reportViewTrace()
  },
  methods: {
    goEnroll () {
      this.$router.push({
        path: '/activity/workshop-video/enroll',
        query: {
          from: this.from
        }
      })
    }
  }
}
</script>

<style scoped>

.container{
  width: 100vw;
  position: relative;
}
.activity-img{
  width: 100%;
  position: relative;
}
.gotoBtn{
  width: 77vw;
  position:absolute;
  left: 11vw;
  bottom: 3vh;
}
</style>
